import React from "react";

function DataAnalysisIcon({ height = "80", width = "80", className = "" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className={className}
        d="M17.1215 4.63169C17.1215 5.37448 16.9018 6.05819 16.5301 6.64905L19.1663 9.27414L17.9665 10.4727L15.3302 7.8392C14.7472 8.21059 14.0543 8.43005 13.3108 8.43005C11.2152 8.43005 9.51687 6.73345 9.51687 4.63169C9.51687 2.52994 11.2152 0.833334 13.3192 0.833334C15.4232 0.833334 17.1215 2.52994 17.1215 4.63169ZM11.2068 4.63169C11.2068 5.79653 12.1532 6.74189 13.3192 6.74189C14.4853 6.74189 15.4316 5.79653 15.4316 4.63169C15.4316 3.46686 14.4853 2.52149 13.3192 2.52149C12.1532 2.52149 11.2068 3.46686 11.2068 4.63169ZM2.53966 16.6285H14.4863V11.5138H16.1929V16.6285C16.1929 17.5661 15.4249 18.3333 14.4863 18.3333H2.53966C1.601 18.3333 0.833008 17.5661 0.833008 16.6285V4.69434C0.833008 3.75666 1.601 2.98946 2.53966 2.98946H7.65963V4.69434H2.53966V16.6285ZM11.0729 14.9236V11.5138H12.7796V14.9236H11.0729ZM9.36629 14.9236H7.65963V8.10409H9.36629V14.9236ZM5.95298 9.80896V14.9236H4.24632V9.80896H5.95298Z"
        fill="#000"
      />
    </svg>
  );
}

export default DataAnalysisIcon;
